import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import SnoozeSubMenu from '../components/SnoozeSubMenu';

export default function getSnoozeSubMenu(
    dueDate: string,
    calendarButtons: IContextualMenuItem[],
    isPaymentScheduled: boolean
): JSX.Element {
    return SnoozeSubMenu({
        dueDate: dueDate,
        calendarButtons: calendarButtons,
        isPaymentScheduled: isPaymentScheduled,
    });
}
